import React, { useState, useEffect } from 'react';
import ModalPortal from 'components/Modal';
import { ModalBorrarTarjeta } from 'pages/Credito/7-Modals'

import { removeStorage } from 'functions/storageBase64'
import { getCardStatus } from 'services/Cards'
import { useIsMobile } from 'hooks/useIsMobile'
import { dataLayerButtons } from 'functions/dataLayerFunction'


export function RemoveCardSears(props){
    const {
        dataSaldos,
        setUdCard
    } = props

    const [showModalBorrarTarjeta, SetShowModalBorrarTarjeta] = useState(false);
    const [borrar, setBorrarT] = useState(false);
    const { isMobile } = useIsMobile();

    // cerrar modal de tarjeta duplicada
    const handleClose = () => SetShowModalBorrarTarjeta(false);

    // realiza encendio / apagado de la tarjeta
    const [responseActive, setResponseActive] = useState()
    const handleBorrar = () => {
        SetShowModalBorrarTarjeta(true);
    };
    // no deseo  apagar la tarjeta (modal)
    const noRemove = () => {
        SetShowModalBorrarTarjeta(false);
        setBorrarT(true)
    };
    
    // si deseo  apagar la tarjeta (modal)
    const siRemove = () => {
        SetShowModalBorrarTarjeta(false);
        getCardStatus({dataCard:{cardending: dataSaldos.cardending, no_internet: dataSaldos.noInternet, active: 2 }})
        .then(setResponseActive)
        setBorrarT(false)
    };

    useEffect(()=>{
        if(responseActive){
            dataLayerButtons({eventName: " credito_eliminartarjeta"})
            removeStorage('lastConsultData')
            setUdCard(true)
            setTimeout(function(){
                window.location.reload()
            },700)
        }
    },[responseActive])

    return(
        <>
           <div className={isMobile === 'desktop' ? 'btn gris remove' : "deleteCard"} onClick={handleBorrar}>Eliminar tarjeta</div>
            {showModalBorrarTarjeta &&
                <ModalPortal type="modalSB" onClose={handleClose} >
                    <ModalBorrarTarjeta remvoeAction={siRemove} awaitAction={noRemove}
                        title="Eliminar tarjeta"
                        body={`La tarjeta con terminacion ${dataSaldos.cardending} sera eliminada de tu cuenta`}
                        subBody="¿Deseas Eliminar definitivamente?" />
                </ModalPortal>
            }
        </>
    )
}